import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ItemService } from '../../services/item/item.service';
import { TokenControlService } from "../../services/state/tokenControl.service";
import { LoggedinGuard } from '../../guards/loggedin.guard';
import { AnswerControlService } from '../../services/answer/answerControl.service';
import { WelcomeService } from "../../services/welcome/welcome.service";
import { RoutingValidationService } from "../../services/routingValidation/routing-validation.service";
import { WelcomeDTO } from "../../model/welcome.info";
import { State } from "../../model/state";
import { StateService } from "../../services/state/state.service";
import { DeleteService } from "../../services/data/delete.service";
import { AnswerService } from "../../services/answer/answer.service";
import { CONFIG } from '../../constants/constants';
import { TokenService } from "../../services/state/token.service";
import { AdaptativeService } from "../../services/adaptativeService/adaptative-service";
import { ItemControlService } from "../../services/item/item-control.service";
import { Token } from "../../model/token";
import { SiteApplicationDTO } from "../../model/siteApplication";
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationService } from '../../services/configuration/configuration.service';
import { ConfigurationControlService } from "../../services/configuration/configurationControl.service";
import { NgxSpinnerService } from 'ngx-spinner';
import { LoginService } from "../../services/login/login.service";
// import * as html2canvas from "../../resources/js/html2canvas";
import { CodResp } from '../../constants/codigosMensajes';
import { Combo } from '../../model/combo';
import { ESTADO_SESSION_INFO } from '../../model/estadoSessionInfo';
import { LogElectronService } from '../../services/logElectron/log-electron.service';
import { LOG_EVENT, LOG_LEVEL } from '../../model/eLogElectron';

//Variable del global scope para utilizar jquery
declare var $: any;


@Component({
  selector: 'app-welcome-pre-icfes',
  templateUrl: './welcome-pre-icfes.component.html',
  styleUrls: ['./welcome-pre-icfes.component.css']
})
export class WelcomePreIcfesComponent implements OnInit {

  // identificador del combo seleccionado para realizar el demo
  public idCombo: Combo;

  // Documento completo
  public docCompleto: string;

  /** Usuario para autenticacion */
  public user: string;

  /** Password para autenticacion */
  public password: string;

  // Mensaje de error general para problemas en el login
  public messageError: string;

  /** Almacena mensajes para msotrar a usuario */
  public mensaje: string;

  /** Atributo que indica la sessión que se ha iniciado.*/
  public sesionNumero: number;

  /** Almacena las pruebas disponibles */
  public pruebas: Combo[];

  constructor(private _router: Router,
    private _itemService: ItemService,
    private _tokenController: TokenControlService,
    private _answerController: AnswerControlService,
    private _welcomeDataService: WelcomeService,
    private _stateService: StateService,
    private _deleteService: DeleteService,
    private _answerService: AnswerService,
    private _translateService: TranslateService,
    private _adaptiveService: AdaptativeService,
    public _itemControlService: ItemControlService,
    private _configurationService: ConfigurationService,
    private _configurationControlService: ConfigurationControlService,
    private _spinner: NgxSpinnerService,
    private _loginService: LoginService,
    private _logElectronService: LogElectronService,
    private _routingValidationService: RoutingValidationService,
    private _loggedinGuard: LoggedinGuard) {

    this.sesionNumero = 0;
  }

  ngOnInit() {
    this.docCompleto = this._configurationControlService.documento;
    this.pruebas = this._configurationControlService.pruebasDisponibles;
  }


  /**Encargado de cargar la prueba seleccionada */
  public loadCombo(combo: Combo) {
    this.idCombo = combo;
    this._spinner.show();
    if (combo.idCombo == CONFIG.TEST_CODE_PA_PRO
      || combo.idCombo == CONFIG.TEST_CODE_PA_TYT) {
      this._loggedinGuard.loggedIn = true;
      this._welcomeDataService.idCombo = combo.idCombo;
      this._router.navigate(['/simulate']);
    } else {
      this.loadDemoUser();
    }
  }


  // Encargado de consultar un usuario demo y que sea asociado al combo seleccionado por el usuario
  public loadDemoUser(): Promise<string> {
    return new Promise(resolve => {
      let self = this;
      this._configurationService.getDemoUser(self.idCombo.idCombo.toString(), self.docCompleto).then((res: string) => {
        this.user = res;
        this.password = res;
        if (res) {
          self.login();
          resolve('OK');
        } else {
          resolve(null);
        }
      });
    });
  }

  public login() {
    let self = this;
    if (this.validateCredentials()) {
      this._loginService.login(this.user, this.password, self._configurationControlService.publicIp).then(result => {
        if (result == null) {
          this.errorAutenticate();
          return;
        }
        if (result.estado === 1) {
          self._loggedinGuard.loggedIn = true;
          self._tokenController.token = result;
          sessionStorage.setItem('uuidSesion', self._tokenController.token.uuidSesion);
          self._loginService.saveToken(result);
          let route = null;
          if (result.userType === 1 || result.userType === 5) {
            route = '/welcome';
            self._loginService.loadWelcomeInfo(
              self._tokenController.token.credentialId,
              self._tokenController.token.token,
              self._tokenController.token.tokenId,
              self._configurationControlService.examConfiguration.multiplesesion)
              .then(res => {
                self._welcomeDataService.data = res;
                let idCombo = self._welcomeDataService.data.idCombo;
                self._configurationService.loadExamConfiguration(idCombo,
                  self._tokenController.token.token,
                  self._tokenController.token.tokenId)
                  .then(data => {
                    self._configurationControlService.examConfiguration = data;
                    self._configurationControlService.sessionInfo.ipPublica = self._configurationControlService.publicIp;
                    self._configurationControlService.sessionInfo.fechaIngreso = new Date();
                    self._configurationControlService.sessionInfo.credencial = this._tokenController.token.credentialId;
                    self._configurationControlService.sessionInfo.sesion = null;
                    self._configurationControlService.sessionInfo.estado = ESTADO_SESSION_INFO.LOGIN;
                    try {
                      self._logElectronService.saveLog(LOG_LEVEL.INFO, LOG_EVENT.E_LOGIN, `credentialId=${self._tokenController.token.credentialId}`)
                    } catch (error) { }
                    self._loginService.saveSessionInfo(self._tokenController.getTokenValue(), self._tokenController.token.tokenId + "", ESTADO_SESSION_INFO.LOGIN);
                    self._configurationControlService.credencial = this._tokenController.token.credentialId;
                    self._configurationControlService.idPrueba = self._welcomeDataService.data.sessions[0].subjects[0].subjectCode;
                    self._answerService.resolveAnswers(
                      self._tokenController.token.tokenId,
                      self._tokenController.token.token,
                      self._tokenController.token.credentialId).then(state => {
                        self._itemService.saveState(state);
                        self._stateService.state = state;
                        self.inicializarItemsAdaptativo(0);
                      });

                  });
              });
          }
        } else {
          if (result == null || result.credentialId == null) {
            self.messageError = result.message;
          } else {
            self.messageError = result.message;
          }
          // this._captchaService.reloadCaptcha();
        }
      }, err => {
        self.messageError = CodResp[26].nombre;
        // this._captchaService.reloadCaptcha();
      });
    } else {
      this.errorAutenticate();
    }
  }

  // Se encarga de validar que las credenciales no sean nulas
  public validateCredentials(): boolean {
    let valid = true;
    if (!this.user || this.user.trim() === '') {
      valid = false;
    }
    if (!this.password || this.password.trim() === '') {
      valid = false;
    }
    return valid;
  }

  /** Captura el mensaje para mostrar errores */
  public errorAutenticate() {
    let self = this;
    this._translateService.get('mensaje.usuario.no.valido')
      .subscribe((res: string) => {
        self.messageError = res;
      });
  }

  /**
   * Método que se encarga de llamar al rest para la inicialización de las sesiones.
   */
  public inicializarItemsAdaptativo(sesion: any) {
    let self = this;
    this._adaptiveService.initializeExam(this._tokenController.token.credentialId.toString(),
      this.sesionNumero,
      this._tokenController.token.tokenId,
      this._tokenController.token.token).then(res => {
        var ordenSesion: any;
        ordenSesion = sesion + 1;
        if (res != null && res.idItem != null && res.idItem != "") {
          self._itemService.resolveItemByCode(res.idItem,
            self._tokenController.token.token,
            self._tokenController.token.tokenId, ordenSesion.toString()).then(
              result => {
                self._itemControlService.item = result;
                self._itemControlService.item.orderVisual = res.numeroPregunta;
                self._itemControlService.itemCode = res.idItem;
                self._spinner.hide();
                if (sesion != null) {
                  this._routingValidationService.validateRouting("login2Exam");
                }
              }
            );
        } else {
          this.validarCodigoAdaptativa(res);
          $('#loginModal').modal({ show: 'false' });
          $('#loginModal').modal('hide');
        }
      });
  }

  /**
   * Método que se encarga de validar
   */
  private validarCodigoAdaptativa(res: any) {
    if (res.codigo == "10") {
      this.mensaje = "El estudiante ya ha terminado la prueba. Se cerrará la sesión."
    } else {
      this.mensaje = "Se ha presentado un error en la aplicación. Se cerrará la sesión. Por favor "
        + " contactarse con el aplicador. Código: " + res.codigo;
    }
    $('#adaptiveErrorModal').modal({ show: true });
    this._spinner.hide();
  }

}
